import React, { useEffect, useState } from 'react';
import { Modal, UnstyledButton } from '@mantine/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCreditCard, faMobileScreen } from '@fortawesome/free-solid-svg-icons';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Button } from '../../../../../components/Button';
import classes from './top-payment-choice-dialog.module.scss';

type TopPaymentChoiceDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  onContinueWithPhone: () => void;
};

export const TopPaymentChoiceDialog: React.FC<TopPaymentChoiceDialogProps> = ({
  isOpen,
  onClose,
  onContinueWithPhone,
}) => {
  const [showFixedTerminalMessage, setShowFixedTerminalMessage] = useState(false);

  useEffect(() => {
    if (isOpen) setShowFixedTerminalMessage(false);
  }, [isOpen]);

  return (
    <Modal
      opened={isOpen}
      onClose={onClose}
      centered
      dir="rtl"
      radius="lg"
      size={560}
      title={showFixedTerminalMessage
        ? 'אנא גש לקחת סולק נייח'
        : 'שאל את הלקוח האם התשלום באשראי פיזי או באשראי בפלאפון'}
      classNames={{ title: classes.title }}
      closeButtonProps={{ 'data-testid': 'top-payment-choice-close' } as Record<string, string>}
    >
      {showFixedTerminalMessage ? (
        <div className={classes.message} data-testid="top-physical-credit-message">
          <FontAwesomeIcon icon={faCreditCard as IconProp} className={classes.messageIcon} />
          <p>לא ניתן לקחת תשלום מעל 300 באשראי פיזי במכשיר זה, אנא גש לקחת סולק נייח להשלמת העסקה</p>
          <Button variant="confirm" fullWidth onClick={onClose} dataTestId="top-physical-credit-confirm">
            הבנתי
          </Button>
        </div>
      ) : (
        <div className={classes.options} data-testid="top-payment-choice-dialog">
          <UnstyledButton
            component="button"
            type="button"
            className={classes.option}
            onClick={() => setShowFixedTerminalMessage(true)}
            data-testid="top-payment-choice-physical"
          >
            <FontAwesomeIcon icon={faCreditCard as IconProp} className={`${classes.optionIcon} ${classes.cardIcon}`} />
            <span>אשראי פיזי</span>
          </UnstyledButton>
          <UnstyledButton
            component="button"
            type="button"
            className={classes.option}
            onClick={onContinueWithPhone}
            data-testid="top-payment-choice-phone"
          >
            <FontAwesomeIcon icon={faMobileScreen as IconProp} className={classes.optionIcon} />
            <span>אשראי בפלאפון</span>
          </UnstyledButton>
        </div>
      )}
    </Modal>
  );
};